import requests from './httpService';

const MovableMasterService = {
  getAllMovableMaster(body) {
    return requests.post(`/movablemaster/list`, body);
  },
  
  findMovableMasterList(body) {
    return requests.post(`/movablemaster/find`, body);
  },
  
  createMovableMaster(body) {
    return requests.post('/movablemaster/add', body);
  },
  
  getMovableMasterById(id) {
    return requests.get(`/movablemaster/${id}`);
  },
  
  updateMovableMaster(id, body) {
    return requests.put(`/movablemaster/${id}`, body);
  },
  
  deleteMovableMaster(id) {
    return requests.delete(`/movablemaster/${id}`);
  },
};

export default MovableMasterService;

